import { GenericFieldFactory } from "../../../Common/_generics/GenericFieldFactory";
import { GENERIC_IDS } from "../../_constants/generics.constants";
import { FILTER_DISABLED_ALL } from "../../_constants";

const initialState = {
    user: FILTER_DISABLED_ALL.key,
};

export const ClockinFiltersStore = GenericFieldFactory(GENERIC_IDS.CLOCKINS + "_FILTERS", initialState);
